import { Block, Box, MainContainer } from "../../../styles/basicStyles";
import { useTranslation } from "next-i18next";
import { Technology } from "../../../models/work";
import { colors } from "../../../styles/colors";
import { FC } from "react";
import { GenerateSlug } from "../../../utils/slug";
import Typography from "../../../components/typography";
import Carousel from "../../../components/views/carousel";
import Dot from "../../../components/views/dot";

interface TechnologiesProps {
  technologies: Technology[];
}

const Technologies: FC<TechnologiesProps> = ({ technologies }) => {
  const { t } = useTranslation();

  const technologiesCarousel = technologies?.
    filter(t => !!t.image)?.
    map(t => {
      return { image: t.image.url, text: t.name, url: `/work?technology=${GenerateSlug(t.name)}` };
    }) || [];

  return (
    <>
      {
        technologiesCarousel.length > 0 &&
        <Box
          mt={{ md: 10.625, xxs: 4.5 }}
          mb={{ md: 10.875, xxs: 4.75 }}
          fDirection="column"
        >
          <MainContainer>
            <Box fDirection={{ md: "row", xxs: "column" }}>
              <Block w={{ md: "45%", xxs: "100%" }} mr={{ md: 1, xxs: 0 }}>
                <Typography
                  as='h2'
                  fSize={{ md: 2.5, xxs: 2 }}
                  lHeight={{ md: 3, xxs: 2.688 }}
                  fWeight={700}
                  color={colors.black}
                  maxW={{ md: 19, xxs: "100%" }}
                >
                  {t("TECHNOLOGIES_WE_SPECIALIZE_IN")}
                  <Dot
                    w={{ md: 0.875, xxs: 0.5 }}
                    h={{ md: 0.875, xxs: 0.5 }}
                    ml={0.375}
                  />
                </Typography>
              </Block>
              <Block
                w={{ md: "50%", xxs: "100%" }}
                mt={{ md: 0, xxs: 1.813 }}
                maxW={{ md: 32.438, xxs: "100%" }}
              >
                <Typography
                  fSize={1.063}
                  lHeight={{ md: 1.75, xxs: 1.875 }}
                  fWeight={400}
                  color={colors.chineseBlack}
                >
                  {t("TECHNOLOGIES_WE_SPECIALIZE_IN_DESCRIPTION")}
                </Typography>
              </Block>
            </Box>
          </MainContainer>
          <Box mt={{ md: 8.125, xxs: 3.688 }} display="flex">
            <Carousel array={technologiesCarousel} />
          </Box>
        </Box>
      }
    </>
  );
};

export default Technologies;
